import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    deficiencyAddFilesDialogCont: {
      padding: 5,
    },
    deficiencyAddFilesDialogGrid: {
      marginRight: 22,
      fontWeight: 700,
      lineHeight: '20px',
    },
    deficiencyAddFilesCancelLink: {
      textDecoration: 'none',
    },
    addPhotosSaveBtn: {
      height: 44,
      width: 65,
    },
    card: {
      padding: '16px',
    },
    AddButton: {
      height: 44,
      width: 102,
    },
    deficiencyUpdateImageGrid: {
      display: 'flex',
      flexDirection: 'row',
      '& .deficiencyUpdateImageFileName': {
        padding: '8px 0px 16px',
        color: 'rgba(255, 255, 255, 0.87)',
      },
      '& .deficiencyUpdateImageFileDesc': {
        paddingTop: '8px',
        color: 'rgba(255, 255, 255, 0.87)',
      },
    },
    muiAlert: {
      width: 'maxContent',
      display: 'inline-flex',
    },
  }),
);

export default useStyles;
